export default "__VITE_ASSET__D2I9GMn7__"